/**
 * Copyright © 2026 Adnuntius AS.
 *
 * API-key admin list and editor.
 */
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {UIRouterModule} from '@uirouter/angular';
import {ButtonsModule} from 'ngx-bootstrap/buttons';

import {AppSharedModule} from '../../common/app-shared.module';
import {AdminListModule} from '../../common/directives/admin-list.module';
import {FormControlsModule} from '../../common/directives/form-controls/form-controls.module';
import {ApiKeyEditPageComponent} from './api-key-edit-page.component';
import {ApiKeyListPageComponent} from './api-key-list-page.component';
import {ApiKeyRoutePageComponent} from './api-key-route-page.component';
import {McpAuthorizePageComponent} from './mcp-authorize-page.component';

const API_KEY = [
  ApiKeyEditPageComponent,
  ApiKeyListPageComponent,
  ApiKeyRoutePageComponent,
  McpAuthorizePageComponent
];

@NgModule({
  imports: [
    AppSharedModule,
    FormsModule,
    TranslateModule,
    UIRouterModule,
    ButtonsModule,
    AdminListModule,
    FormControlsModule
  ],
  declarations: API_KEY,
  exports: API_KEY
})
export class ApiKeyModule {
}
